import AuthService from "../services/AuthService/AuthService";
import AutomService from "../services/AutomService/AutomService";
import MateService from "../services/MateService/MateService";

import jwtDecode from 'jwt-decode';
import moment from 'moment-timezone';
import { chromeLight, ObjectInspector, ObjectLabel } from "react-inspector";


// Import Variable Icons
import ArrayIcon from '../assets/icons/variableIcons/array';
import DataTableIcon from '../assets/icons/variableIcons/dataTable';
import DateIcon from '../assets/icons/variableIcons/date';
import DictionaryIcon from '../assets/icons/variableIcons/dictionary';
import NumberIcon from '../assets/icons/variableIcons/number';
import ObjectIcon from '../assets/icons/variableIcons/object';
import StringIcon from '../assets/icons/variableIcons/string';
import BooleanIcon from '../assets/icons/variableIcons/boolean';
import CredentialService from "../services/CredentialService/CredentialService";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { useState } from "react";
import { Tooltip } from "@material-ui/core";


export const convertToDateFormat = (date, format, hasTime = true, timeZone) => {
    const d = new Date(date);
    // const d = moment(date).toDate();

    if (isNaN(d)) {
        return date;
    }
    const yyyy = d.getFullYear();
    let mm = addZero(d.getMonth() + 1); // Months start at 0!
    let dd = addZero(d.getDate());
    let time = `${addZero(d.getHours())}:${addZero(d.getMinutes())}:${addZero(d.getSeconds())}`;

    if (format) {
        format = format.replace("MM", mm.toString());
        format = format.replace("dd", dd.toString());
        format = format.replace("yyyy", yyyy.toString());

        return hasTime ? `${format} ${time}` : format;
    } else {
        return d.toLocaleString();
    }

    function addZero(t) {
        if (t < 10) {
            return '0' + t;
        }
        return t;
    }
}

export const conditionalOperators = {
    "eq": {
        "text": "equals",
        "value": "eq"
    },
    "neq": {
        "text": "does not equal",
        "value": "neq"
    },
    "gt": {
        "text": "greater than",
        "value": "gt"
    },
    "lt": {
        "text": "less than",
        "value": "lt"
    },
    "ct": {
        "text": "contains",
        "value": "ct"
    },
    "nct": {
        "text": "does not contain",
        "value": "nct"
    },
    "sw": {
        "text": "starts with",
        "value": "sw"
    },
    "nsw": {
        "text": "does not start with",
        "value": "nsw"
    },
    "ew": {
        "text": "ends with",
        "value": "ew"
    },
    "new": {
        "text": "does not end with",
        "value": "new"
    },
    "t": {
        "text": "is true",
        "value": "t"
    },
    "nt": {
        "text": "is not true",
        "value": "nt"
    },
    "e": {
        "text": "is exists",
        "value": "e"
    },
    "ne": {
        "text": "is not exist",
        "value": "ne"
    }
}

export const convertToOnlyDateFormat = (date, format, hasTime = true) => {
    const d = new Date(date);
    if (isNaN(d)) {
        return date;
    }
    const yyyy = d.getFullYear();
    let mm = addZero(d.getMonth() + 1); // Months start at 0!
    let dd = addZero(d.getDate());

    if (format) {
        format = format.replace("MM", mm.toString());
        format = format.replace("dd", dd.toString());
        format = format.replace("yyyy", yyyy.toString());

        return format;
    } else {
        return d.toLocaleString();
    }

    function addZero(t) {
        if (t < 10) {
            return '0' + t;
        }
        return t;
    }
}

export const isFloat = (n) => {
    return Number(n) === n && n % 1 !== 0;
}

export const isInt = (n) => {
    return Number(n) === n && n % 1 === 0;
}

export const getExtension = (filename) => {
    let parts = filename.split(".");
    return parts[parts.length - 1];
};

export const hasSubItemsPermission = (permissionList, tag, subitems) => {
    if (subitems) {
        for (let i of subitems) {
            if (permissionList?.includes(i.tag)) {
                return true;
            }
        }
        return false;
    }
    return permissionList?.includes(tag);
};

export const setServiceMessage = (data, prefix) => {
    let suffix = data.message;
    data.message = prefix + suffix;
    return data;
};

export const capitalizeFirstLetter = (string) => {
    return string.replace(/^./, string[0].toUpperCase());
}

export const getCaretPosition = (element) => {
    let position = 0;
    const isSupported = typeof window.getSelection !== "undefined";
    if (isSupported) {
        const selection = window.getSelection();
        // Check if there is a selection (i.e. cursor in place)
        if (selection.rangeCount !== 0) {
            // Store the original range
            const range = window.getSelection().getRangeAt(0);
            // Clone the range
            const preCaretRange = range.cloneRange();
            // Select all textual contents from the contenteditable element
            preCaretRange.selectNodeContents(element);
            // And set the range end to the original clicked position
            preCaretRange.setEnd(range.endContainer, range.endOffset);
            // Return the text length from contenteditable start to the range end
            position = preCaretRange.toString().length;
        }
    }
    return position;
};

export const findElementName = (flow, currentName) => {
    let count = 0;
    let value;
    for (const item of flow) {
        if ((item.type === "autom" || item.type === "process") && item.fields) {
            value = item.fields.elementName?.value;
            if (value === currentName) {
                count += 1;
                if (count > 1) {
                    return true;
                }
            }
        }
    }
    return false;
};

//type process or autom
export const getAutomNamesIDs = (flow) => {
    let data = [];
    let name;
    let id;

    for (const item of flow) {
        if ((item.type === "autom" || item.type === "process") && item.fields) {
            id = item.fields.autom?.value;
            name = item.fields.elementName?.value;
            if (name && id) {
                data.push({ id, name });
            }
        }
    }
    return data;
};


export const flowMouseWheelListener = () => {
    const el = document.getElementById("alt-area");
    el.addEventListener("wheel", (event) => {
        const flow = document.getElementById("drag-me");
        const delta = Math.sign(event.deltaY);
        const offsetChangeValue = 64;
        const topPosition = document.getElementById("drag-me").offsetTop;

        if (delta === -1)
            flow.style.top = (topPosition + offsetChangeValue).toString() + "px";
        else flow.style.top = (topPosition - offsetChangeValue).toString() + "px";
    });
};

export const checkEquality = (array, variables, forLoopCount) => {
    let attributes = [];
    for (let i = 0; i < forLoopCount; i++) {
        let attribute = {};
        if (array[i].name !== variables.attributes[i].name) {
            attribute.connection_attribute_id = variables.attributes[i].id;
            if (!attribute.willBeUpdatedFields) {
                attribute.willBeUpdatedFields = [
                    {
                        field_name: "name",
                        field_value: array[i].name,
                    },
                ];
            } else {
                attribute.willBeUpdatedFields.push({
                    field_name: "name",
                    field_value: array[i].name,
                });
            }
        }

        if (array[i].description !== variables.attributes[i].description) {
            attribute.connection_attribute_id = variables.attributes[i].id;

            if (!attribute.willBeUpdatedFields) {
                attribute.willBeUpdatedFields = [
                    {
                        field_name: "description",
                        field_value: array[i].description,
                    },
                ];
            } else {
                attribute.willBeUpdatedFields.push({
                    field_name: "description",
                    field_value: array[i].description,
                });
            }
        }

        //if there is no any change input, I will have to add current switch states to array beacause couldn't check equalty of true false statement...
        attribute.connection_attribute_id = variables.attributes[i].id;
        if (!attribute.willBeUpdatedFields) {
            attribute.willBeUpdatedFields = [
                {
                    field_name: "masked_flag",
                    field_value: array[i].masked_flag,
                },
                {
                    field_name: "user_provided_flag",
                    field_value: array[i].user_provided_flag,
                },
            ];
        } else {
            attribute.willBeUpdatedFields.push(
                {
                    field_name: "masked_flag",
                    field_value: array[i].masked_flag,
                },
                {
                    field_name: "user_provided_flag",
                    field_value: array[i].user_provided_flag,
                }
            );
        }

        attributes = [...attributes, attribute];
    }

    return attributes;
};

export const isChecked = (
    catName,
    id,
    setFilter,
    filter,
    setTempChipList,
    tempChipList,
    item
) => {
    let copyFilter = { ...filter };
    if (catName === "Category") {
        if (!filter?.category_id) {
            copyFilter = { ...copyFilter, category_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                category_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.category_id = [...copyFilter.category_id, id]
            setFilter(copyFilter, copyFilter.category_id);
            const category_id = [
                ...tempChipList.category_id,
                {
                    item_name: item.name,
                    item_id: id
                }
            ]
            // tempChipList.category_id = [
            //     ...tempChipList.category_id,
            //     {
            //         item_name: item.name,
            //         item_id: id
            //     }
            // ]
            setTempChipList({ ...tempChipList, category_id });
            // setTempChipList(tempChipList, tempChipList.category_id);
        }
    } else if (catName === "Business Process") {
        if (!filter?.business_process_id) {
            copyFilter = { ...copyFilter, business_process_id: [id] }
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                business_process_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.business_process_id = [...copyFilter.business_process_id, id]
            setFilter(copyFilter, copyFilter.business_process_id);
            const business_process_id = [...tempChipList.business_process_id,
            { item_name: item.name, item_id: id }
            ]
            setTempChipList({ ...tempChipList, business_process_id });
        }
    } else if (catName === "Automation Type") {
        if (!filter?.automation_type_id) {
            copyFilter = { ...copyFilter, automation_type_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                automation_type_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.automation_type_id = [...copyFilter.automation_type_id, id]
            setFilter(copyFilter, copyFilter.automation_type_id);
            const automation_type_id = [
                ...tempChipList.automation_type_id,
                {
                    item_name: item.name,
                    item_id: id,
                },
            ]
            setTempChipList({ ...tempChipList, automation_type_id });
        }
    } else if (catName === "Security Stage") {
        if (!filter?.security_stage_id) {
            copyFilter = { ...copyFilter, security_stage_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                security_stage_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.security_stage_id = [...copyFilter.security_stage_id, id]
            setFilter(
                copyFilter,
                copyFilter.security_stage_id
            );
            const security_stage_id = [
                ...tempChipList.security_stage_id,
                {
                    item_name: item.name,
                    item_id: id,
                },
            ]
            setTempChipList(
                {
                    ...tempChipList,
                    security_stage_id
                }
            );
        }
    } else if (catName === "Application") {
        if (!filter?.application_id) {
            copyFilter = { ...copyFilter, application_id: [id] };
            setFilter(copyFilter);
            setTempChipList({
                ...tempChipList,
                application_id: [{ item_name: item.name, item_id: id }],
            });
        } else {
            copyFilter.application_id = [...copyFilter.application_id, id]
            setFilter(
                copyFilter,
                copyFilter.application_id
            );
            const application_id = [
                ...tempChipList.application_id,
                {
                    item_name: item.name,
                    item_id: id,
                },
            ]
            setTempChipList(
                {
                    ...tempChipList,
                    application_id
                }
            );
        }
    }
    return copyFilter;
};
export const isUnChecked = (
    catName,
    id,
    setFilter,
    filter,
    setTempChipList,
    tempChipList
) => {
    let copyFilter = { ...filter };
    const copyTempChipList = JSON.parse(JSON.stringify(tempChipList))
    if (catName === "Category") {
        const tempArr = filter?.category_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList?.category_id?.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.category_id;
            delete copyTempChipList.category_id;
            setFilter(copyFilter);
            setTempChipList(copyTempChipList);
        } else {
            copyFilter.category_id = tempArr
            setFilter(copyFilter, copyFilter.category_id);
            const category_id = tempFilterTagArr
            setTempChipList(
                {
                    ...tempChipList,
                    category_id
                }
            );
        }

    } else if (catName === "Business Process") {
        const tempArr = filter?.business_process_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList?.business_process_id?.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.business_process_id;
            delete copyTempChipList.business_process_id;
            setFilter(copyFilter);
            setTempChipList(copyTempChipList);
        } else {
            copyFilter.business_process_id = tempArr
            setFilter(copyFilter, copyFilter.business_process_id);
            const business_process_id = tempFilterTagArr
            setTempChipList(
                {
                    ...tempChipList,
                    business_process_id
                }
            );
        }
    } else if (catName === "Automation Type") {
        const tempArr = filter?.automation_type_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList?.automation_type_id?.filter(
            (item) => item.item_id !== id
        );

        if (tempArr?.length === 0) {
            delete copyFilter.automation_type_id;
            delete copyTempChipList.automation_type_id;
            setFilter(copyFilter);
            setTempChipList(copyTempChipList);
        } else {
            copyFilter.automation_type_id = tempArr
            setFilter(copyFilter, copyFilter.automation_type_id);
            const automation_type_id = tempFilterTagArr
            // tempChipList.automation_type_id = tempFilterTagArr
            setTempChipList(
                {
                    ...tempChipList,
                    automation_type_id
                }
            );
            // setTempChipList(
            //     setTempChipList,
            //     tempChipList.automation_type_id
            // );
        }
    } else if (catName === "Security Stage") {
        const tempArr = filter?.security_stage_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList.security_stage_id.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.security_stage_id;
            delete copyTempChipList.security_stage_id;
            setFilter(copyFilter);
            setTempChipList(copyTempChipList);
        } else {
            copyFilter.security_stage_id = tempArr
            setFilter(copyFilter, copyFilter.security_stage_id);
            const security_stage_id = tempFilterTagArr
            setTempChipList(
                {
                    ...tempChipList,
                    security_stage_id
                }
            );
        }
    } else if (catName === "Application") {
        const tempArr = filter?.application_id?.filter((item) => item !== id);
        const tempFilterTagArr = tempChipList.application_id.filter(
            (item) => item.item_id !== id
        );
        if (tempArr?.length === 0) {
            delete copyFilter.application_id;
            delete copyTempChipList.application_id;
            setFilter(copyFilter);
            setTempChipList(copyTempChipList);
        } else {
            copyFilter.application_id = tempArr
            setFilter(copyFilter, copyFilter.application_id);
            const application_id = tempFilterTagArr
            setTempChipList(
                {
                    ...tempChipList,
                    application_id
                }
            );
        }
    }
    return copyFilter;
};

export const isActionValueController = (values, credentials) => {
    let val1 = Object.entries(values);
    return val1.map(function (item) {
        if (item[0] === 'sys_action_fields' && item[1].value) {
            const isOk = isActionValueController(item[1].value)
            if (isOk.indexOf(false) !== -1) {
                return false;
            }
        }
        if (item[1].isRequired) {
            if (item[1].value !== null && item[1].value !== undefined && item[1].value !== "") {
                if (item[1]?.type === "CONDITION" && Array.isArray(item[1].value)) {
                    return item[1].value.length ? true : false;
                } else if (item[1]?.type === "ARRAY") {
                    if (Array.isArray(item[1].value)) {
                        return item[1].value.length ? true : false;
                    } else if (typeof item[1].value === "object") {
                        return Object.keys(item[1].value).length ? true : false;
                    }
                }
                else if (item[1].type === "CREDENTIALPICKER") {
                    const isMatched = credentialMatch(item[1].value, credentials)
                    if (!isMatched) return false
                }
                return item[1].value.length > 0 || item[1].value || !item[1].value;
            } else {
                return false;
            }
        }
    });
};

const fetchCredentials = async () => {
    const response = await CredentialService.getCredentials("1");
    if (response) {
        return response.data
    }
}
const credentialMatch = (value, credentials) => {
    if (typeof value === 'object') {
        const isFind = credentials.find((item) => item.connection_id === value.credentialId)
        if (isFind) {
            return value.attributeId ? true : false
        }
        return false
    }
    else if (value) {
        return true
    }
    else {
        return false
    }
}

export const valueController = async (state, isControlArray) => {
    const credentials = await fetchCredentials()
    let elem;
    for (const item of state) {
        if (item["fields"] !== undefined) {
            elem = document.getElementById("flow-warning" + item.id);
            let val = isActionValueController(item.fields, credentials);
            if (val.indexOf(false) !== -1) {
                isControlArray.push(false);
                if (elem) elem.style = "visibility:visible";
            } if ('children' in item) {
                if (elem && !(val.indexOf(false) !== -1)) elem.style = "visibility:hidden";
                await valueController(item.children, isControlArray);
            } else if (!(val.indexOf(false) !== -1)) {
                isControlArray.push(true);
                if (elem) elem.style = "visibility:hidden";
            }
        } else if ('children' in item) {
            await valueController(item.children, isControlArray);
        } else if (item.name !== 'START' && elem) elem.style = "visibility:visible";
        if (item["eh_flow"] !== undefined) {
            await valueController(item.eh_flow.items, isControlArray);
        }
    }


    return isControlArray;
};

/**
 * @Description sort order data edit
 * @Param       operation_status : ipaas or rpa
 * @Param       data :  data is a pending or inprogress data
 * @Param       clickIndex : clicked data index
 * @Param       operation : clicked button "up" or "down"
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function handleSortOrder(operation_status, data, clickIndex, operation) {
    // check ipaas or rpa
    const operationType = localStorage.getItem("pf");
    //initial Data
    const orders = [];
    //click up button
    if (operation === "up") {
        orders.push(
            {
                id: data[clickIndex]?.id,
                queue_order: data[clickIndex]?.queue_order - 1,
            },
            {
                id: data[clickIndex - 1]?.id,
                queue_order: data[clickIndex]?.queue_order,
            }
        );
        const itemNow = data[clickIndex];
        const itemChange = data[clickIndex + 1];
        //swap data undefined control
        if (itemNow && itemChange) {
            //we swap data
            data[clickIndex] = itemChange;
            data[clickIndex - 1] = itemNow;
        }
    }
    //click down button operation is 'down'
    else {
        orders.push(
            {
                id: data[clickIndex]?.id,
                queue_order: data[clickIndex]?.queue_order + 1,
            },
            {
                id: data[clickIndex + 1]?.id,
                queue_order: data[clickIndex]?.queue_order,
            }
        );
        const itemNow = data[clickIndex];
        const itemChange = data[clickIndex + 1];
        //swap data undefined control
        if (itemNow && itemChange) {
            //we swap data
            data[clickIndex] = itemChange;
            data[clickIndex + 1] = itemNow;
        }
    }

    return {
        operation_status: operation_status.toUpperCase(),
        operationType,
        orders
    };
}

/**
 * @Description formating time
 * @Param       sec : seconds
 * @Returns     string
 * @Author      ibrahim AKIN
 */
export function SecFormatter(sec) {
    /* extend the String by using prototypical inheritance */
    let seconds = parseInt(sec, 10); // don't forget the second param
    let hours = Math.floor(seconds / 3600);
    let minutes = Math.floor((seconds - (hours * 3600)) / 60);
    seconds = seconds - (hours * 3600) - (minutes * 60);
    let time = '';  // = hours+':'+minutes+':'+seconds;
    if (hours > 0) {
        time += hours + 'h ';
    }
    if (hours > 0 || minutes > 0) {
        time += minutes + 'm ';
    }
    if (seconds > 0) {
        time += seconds + 's';
    }
    return time;
}


/**
 * @Description convert byte to size
 * @Param      bytes : byte value
 * @Returns     number
 * @Author      Kerem Karadeniz
 */
export function formatBytes(bytes, decimals = 2) {
    if (bytes === 0) return '0 Bytes';

    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

    const i = Math.floor(Math.log(bytes) / Math.log(k));

    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
}

/**
 * @Description email control
 * @Param       email : text
 * @Returns     text
 * @Author      Kerem Karadeniz
 */

export function validateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

/**
 * @Description sort object key
 * @Param       object
 * @Param       key
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function sortObjects(object, key) {
    object.sort((a, b) => a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0)
}

/**
 * @Description set object order  sort
 * @Param       mainState
 * @Param       order
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function changeOrder(mainState, order) {
    let newOrder = order ? order : 0;
    const promise = mainState?.map((item) => {
        return new Promise((resolve) => {
            if (item.actionName !== "TRIGGER") {
                if ('children' in item) {
                    item.order = newOrder;
                    newOrder++;
                    newOrder = changeOrder(item.children, newOrder);
                } else {
                    item.order = newOrder;
                    newOrder++;
                }
            }
            resolve(true);
        });
    });

    Promise.all(promise);
    return newOrder;
}

/**
 * @Description set debug array
 * @Param       data
 * @Returns     object
 * @Author      Kerem Karadeniz
 */

export function handleDebugArray(data) {
    return new Promise(async (resolve, reject) => {
        for (let i = 0; i < data.length; i++) {
            const element = data[i];
            if (element.isDebugging) {
                const dataL = data.length;
                for (let index = i + 1; index < dataL; index++) {
                    data.pop();
                }
                resolve(data);
                break;
            } else if (element.children && element.children.length > 0) {
                const children = await handleDebugArray(element.children);
                if (children) {
                    element.children = children;
                    const dataL = data.length;
                    for (let index = i + 1; index < dataL; index++) {
                        data.pop();
                    }
                    resolve(data);
                    break;
                }
            }
        }
        resolve(undefined);
    });
}

/**
 * @Description finding debug action
 * @Param       nodes
 * @Param       debugAction
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function findDebugAction(nodes, debugAction) {
    for (const item of nodes) {
        if (item.isDebugging === true) {
            debugAction.push(item);
        } else if (item.acceptNewChildren === true) {
            findDebugAction(item.children, debugAction);
        }
    }
}

/**
 * @Description edit data run action
 * @Param       node
 * @Returns     object
 * @Author      Kerem Karadeniz
 */
export function editDataRun(node) {
    node.map((item) => {
        if (item.acceptsNewChildren) {
            editDataRun(item.children);
        } else {
            delete item.children;
        }
        delete item.source;
        delete item.accepts;
        delete item.image;
        delete item.type;
        delete item.item;
        delete item.id;
        return item;
    });
    return node;
}

/**
 * @description generation query params
 * @returns     string - query param as string
 * @param       obj - query param as object
 * @author      Onur DOGUCU
 */
export function queryParamGenerator(obj) {
    let filter = "?";
    let counter = 0;
    const size = Object.keys(obj).length;
    for (const key in obj) {
        if (counter === size - 1) {
            filter += `${key}=${obj[key]}`
        } else {
            filter += `${key}=${obj[key]}&`
        }
        counter++;
    }

    return filter;
}

/**
 * @description get the value from the json by using search filter value
 * @returns     any
 * @param       o - source value
 * @param       s - searching value
 * @param       v - value to match
 * @param       g - will be obtained value
 * @author      Onur DOGUCU
 */
export function getValueFromJSON(o, s, v = undefined, g = undefined) {
    if (!s) return o;
    s = s.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
    s = s.replace(/^\./, '');           // strip a leading dot
    let a = s.split('.');
    for (let i = 0, n = a.length; i < n; ++i) {
        if (a[i] === "*") {
            if ((i + 1) !== n) {
                o = o.find(x => x[a[i + 1]] === v);

            }
        } else {
            let k = a[i];
            if (o && k in o) {
                if (g && g === "*") {
                    return o;
                } else {
                    o = o[k];
                }
            } else {
                return;
            }
        }

    }

    return o;
}

/**
 * This function get variable array match. Exp: ##test[0][name]## => ##test[0][name]##, test, 0, name
 * @param     {string}  value
 * @returns   {array}
 * @Author      Abdullah Onur Yeşil
 */
export function GetVariableArrayMatch(value) {
    let count = (value.match(/\[/g) || []).length;
    let exp = `##(.*)`;
    for (let i = 0; i < count; i++) {
        exp += `\\[(.*)]`
    }
    exp += "##"
    return value.match(exp)
}

export async function GenerateJWTToken(payload) {
    return await AuthService.oAuthGenerate(payload);
}

/**
 * this function converts column index to letter
 * @param     {number}  num
 * @returns   {string}
 * @Author      Abdullah Onur Yeşil
 */
export function numberToLetters(num) {
    let letters = ''
    while (num >= 0) {
        letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'[num % 26] + letters
        num = Math.floor(num / 26) - 1
    }
    return letters
}

/**
 * this function converts letters to column number. Not column index
 * @param     {string}  val
 * @returns   {number}
 * @Author      Abdullah Onur Yeşil
 */
export function lettersToNumber(val) {
    var base = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ', i, j, result = 0;

    for (i = 0, j = val.length - 1; i < val.length; i += 1, j -= 1) {
        result += Math.pow(base.length, j) * (base.indexOf(val[i]) + 1);
    }

    return result;
};
export function ConvertJSONtoQueryString(data) {
    const searchParams = new URLSearchParams();

    Object.entries(data).forEach(([key, value]) => {
        searchParams.append(key, value);
    });

    return searchParams.toString();
}

export function checkIsDate(date) {
    let isDate;
    isDate = moment(date, [
        'YYYY-MM-DD',
        'DD/MM/YYYY',
        'MM/DD/YYYY',
        'YYYY-MM-DDTHH:mm:ssZ',
        'YYYY-MM-DDTHH:mm:ss.SSSZ',
    ], true).isValid();
    if (!isDate) {
        isDate = moment(date, [
            'YYYY-MM-DD HH:mm:ss',
            'DD/MM/YYYY HH:mm:ss',
            'MM/DD/YYYY HH:mm:ss',
            'YYYY-MM-DDTHH:mm:ssZ',
            'YYYY-MM-DDTHH:mm:ss.SSSZ',
        ], true).isValid();
    }

    return isDate;
}

export function checkSpecialCharacter(v, whiteSpace = false) {
    let regex;
    if (whiteSpace) {
        regex = /^[A-Za-z0-9\s_.()-]*$/;
    } else {
        regex = /^[A-Za-z0-9_.()-]*$/;
    }
    // let regex = /^[A-Za-z0-9\s_-]*$/;
    return v.search(regex)
}

export function getImageColors(img, callback) {
    if (img) {
        let base_image = new Image();
        // set src with library image
        base_image.src = img;
        base_image.crossOrigin = "Anonymous";
        base_image.onload = function () {
            // create canvas
            const canvas = document.createElement('canvas');
            canvas.width = base_image.width;
            canvas.height = base_image.height;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(base_image, 0, 0);
            const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
            const data = imageData.data;

            // Sum the color values of all non-transparent pixels
            let red = 0;
            let green = 0;
            let blue = 0;
            let pixelCount = 0;

            for (let i = 0; i < data.length; i += 4) {
                const alpha = data[i + 3];
                if (alpha > 0) {
                    red += data[i];
                    green += data[i + 1];
                    blue += data[i + 2];
                    pixelCount++;
                }
            }

            // Get the average color of all non-transparent pixels
            if (pixelCount > 0) {
                red = Math.floor(red / pixelCount);
                green = Math.floor(green / pixelCount);
                blue = Math.floor(blue / pixelCount);
            }

            // set dynamic colors
            let background = `rgb(${red}, ${green}, ${blue})`;
            let color = getContrastingColor(background);
            callback({ background, color });
            // setDynamicBackgrounColor(`rgb(${red}, ${green}, ${blue})`);
            // setDynamicColor(getContrastingColor(background));
        }
    } else {
        callback({ background: '#666469', color: 'white' });
    }
}

export function sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
}

// Function to calculate the perceived brightness of a color
function getLuma(color) {
    const [r, g, b] = color.match(/\d+/g).map(n => Number(n));
    return (0.2126 * r) + (0.7152 * g) + (0.0722 * b);
}

// Function to get contrasting color
function getContrastingColor(color) {
    const luma = getLuma(color);
    return luma > 186 ? '#000000' : '#ffffff';
}

export function getShade(color, shade) {
    let r, g, b;

    if (color.match(/^rgb/)) {
        color = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/);

        r = parseInt(color[1]);
        g = parseInt(color[2]);
        b = parseInt(color[3]);
    } else {
        color = +("0x" + color.slice(1).replace(
            color.length < 5 && /./g, '$&$&'));

        r = color >> 16;
        g = color >> 8 & 255;
        b = color & 255;
    }

    r = Math.min(Math.max(0, r + shade), 255);
    g = Math.min(Math.max(0, g + shade), 255);
    b = Math.min(Math.max(0, b + shade), 255);

    return `rgb(${r}, ${g}, ${b})`;
}

/**
 * this function returns the action with the given item_id
 * @param     {string}  item_id
 * @param     {Array}   items
 * @returns   {object}
 * @Author      Abdullah Onur Yeşil
 */
export function findActionById(item_id, items) {
    return new Promise(async (resolve) => {
        let foundItem;
        for (let item of items) {
            if (item.item_id === item_id) {
                foundItem = item;
                break;
            } else if (item.children) {
                foundItem = await findActionById(item_id, item.children);
                if (foundItem) {
                    break;
                }
            }
        }
        resolve(foundItem);
    });
}

/**
 * this function returns parent action with the given item_id
 * @param     {string}  item_id
 * @param     {Array}   items
 * @returns   {object}
 * @Author      Abdullah Onur Yeşil
 */
export function findParentActionById(item_id, items, root) {
    return new Promise(async (resolve) => {
        let foundItem = {};
        for (let item of items) {
            if (item.item_id === item_id) {
                if (root) {
                    //resolve(items);
                    foundItem = { children: items };
                } else {
                    foundItem = { found: true };
                }
                break;
            } else if (item.children) {
                foundItem = await findParentActionById(item_id, item.children, false);
                if (foundItem.found) {
                    //resolve(item);
                    if (item.item_id) {
                        foundItem = item;
                    }
                    break;
                } else if (foundItem.item_id) {
                    break;
                }
            }
        }
        resolve(foundItem);
    });
}

/**
 * this function returns parent scope action with the given item_id
 * @param     {string}  item_id
 * @param     {Array}   items
 * @returns   {object}
 * @Author      Abdullah Onur Yeşil
 */
export function findParentScopeById(item_id, items, root) {
    return new Promise(async (resolve) => {
        let foundItem = {};
        for (let item of items) {
            if (item.item_id === item_id) {
                if (root) {
                    foundItem = { children: items };
                } else {
                    foundItem = { found: true };
                }
                break;
            } else if (item.children) {
                foundItem = await findParentScopeById(item_id, item.children, false);
                if (foundItem.found) {
                    if (item.actionName === 'SCOPE') {
                        foundItem = item;
                    }
                    break;
                } else if (foundItem.item_id) {
                    break;
                }
            }
        }
        resolve(foundItem);
    });
}

export async function findParentLibraryGroup(item_id, items, root, libraryName) {

    let foundItem = {};
    for (let item of items) {
        if (item.item_id === item_id) {
            if (root) {
                foundItem = { children: items };
            } else {
                foundItem = { found: true };
            }
            break;
        } else if (item.children) {
            foundItem = await findParentScopeById(item_id, item.children, false);
            if (foundItem.found) {
                if (item.libraryName === libraryName) {
                    foundItem = item;
                }
                break;
            } else if (foundItem.item_id) {
                break;
            }
        }
    }
    return foundItem
}
export async function findGroupActions(items) {

    let groupActions = [];
    const findGroupableActions = (childItems) => {
        for (let item of childItems) {
            if (item.type === "groupable") {
                groupActions.push(item)
            } if (item.children) {
                findGroupableActions(item.children);
            }
        }
    }
    findGroupableActions(items)
    return groupActions
}

export function findChildScopeById(items) {
    let foundItem = {};
    for (let item of items) {
        if (item.actionName === 'SCOPE') {
            foundItem = item;
            return foundItem
        }
        else if (item.children) {
            foundItem = findChildScopeById(item.children);
            if (foundItem && foundItem.id) {
                return foundItem
            }
        }
        return foundItem
    }
    return foundItem
}
export function findChildDesktopActionById(items) {
    let foundItem = {};
    for (let item of items) {
        if (item.actionName !== "SCOPE") {
            if (item.libraryName === "DESKTOP-ACTIONS") {
                foundItem = item;
                return foundItem
            }
            else if (item.children) {
                foundItem = findChildDesktopActionById(item.children);
                if (foundItem && foundItem.id) {
                    return foundItem
                }
            }
            return foundItem
        }
    }
    return foundItem
}

export function findIfLibraryExist(items, libraryName) {
    let found = false;
    for (let item of items) {
        if (item.libraryName === libraryName) {
            found = true;
            break;
        } else {
            if (item.children) {
                found = findIfLibraryExist(item.children, libraryName);
                if (found) break;
            }
        }
    }
    return found;
}

/**
 * this function returns boolean result of comparing two json
 * @param     {object | Array}  json1
 * @param     {object | Array}   json2
 * @returns   {boolean}
 * @author    Onur DOGUCU
 */
export function isJSONDifferent(json1, json2) {
    // Initialize the difference object
    let difference = {};

    // Check if both inputs are objects or arrays
    if (typeof json1 === "object" && typeof json2 === "object" && json1 !== null && json2 !== null) {
        // Check if both inputs are arrays
        if (Array.isArray(json1) && Array.isArray(json2)) {
            // Check if both arrays have the same length
            if (json1.length !== json2.length) {
                difference["length"] = [json1.length, json2.length];
            }
            // Compare each element of the arrays using recursion
            for (let i = 0; i < json1.length; i++) {
                let subDifference = isJSONDifferent(json1[i], json2[i]);
                if (subDifference) {
                    difference[i] = subDifference;
                }
            }
        } else {
            // Check if both inputs have the same keys
            let keys1 = Object.keys(json1).filter(key => key !== "id");
            let keys2 = Object.keys(json2).filter(key => key !== "id");
            if (keys1.length !== keys2.length) {
                difference["propertyCount"] = [keys1.length, keys2.length];
            }
            // Compare each property of the objects using recursion
            for (let key of keys1) {
                if (!json2.hasOwnProperty(key)) {
                    difference[key] = [json1[key], null];
                } else {
                    let subDifference = isJSONDifferent(json1[key], json2[key]);
                    if (subDifference) {
                        difference[key] = subDifference;
                    }
                }
            }
            for (let key of keys2) {
                if (!json1.hasOwnProperty(key)) {
                    difference[key] = [null, json2[key]];
                }
            }
        }
    } else {
        // Compare values directly, handling null and undefined values
        if (json1 !== json2) {
            difference["value"] = [json1, json2];
        }
    }

    // Log the difference to the console
    return Object.keys(difference).length > 0;
}

/**
 * this function returns boolean result of comparing two json
 * @param     {string}  input_name
 * @param     {object}  action
 * @param     {any}   oldValue
 * @param     {any}   newValue
 * @param     {any}   setSaveAvailable
 * @param     {any}   setChangeFields
 * @param     {any}   changedFieldsState
 * @returns   void
 * @author    Onur DOGUCU
 */
export function CheckIfFlowUpdated(input_name, action, oldValue, newValue, setSaveAvailable, setChangeFields, changedFieldsState) {
    const cfTemp = JSON.parse(JSON.stringify(changedFieldsState));
    switch (typeof oldValue) {
        case "object":
            if (isJSONDifferent(newValue, oldValue)) {
                addDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable);
            } else {
                removeDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable);
            }
            break;
        case "string":
            if (oldValue !== newValue) {
                addDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable);
            } else {
                removeDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable);
            }
            break;
        default:
            if (oldValue !== newValue) {
                addDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable);
            } else {
                removeDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable);
            }
    }

}

export function addDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable) {
    let isChanged = false;
    if (!cfTemp.hasOwnProperty(action?.item_id)) {
        cfTemp[action?.item_id] = [];
        isChanged = true;
    }
    if (cfTemp[action?.item_id].indexOf(input_name) < 0) {
        cfTemp[action?.item_id].push(input_name);
        isChanged = true;
    }

    if (isChanged) {
        setChangeFields(cfTemp)
    }

    setSaveAvailable(true);
}

export function addDifferenceBySet(action, input_name, setChangeFields, setSaveAvailable) {
    setChangeFields((oldObject) => {
        const existingArray = oldObject[action?.item_id] || [];

        if (!existingArray.includes(input_name)) {
            return {
                ...oldObject,
                [action?.item_id]: [...existingArray, input_name],
            };
        }
        return oldObject;
    });

    setSaveAvailable(true);
}

export function removeDifference(cfTemp, action, input_name, setChangeFields, setSaveAvailable) {
    let isChanged = false;
    if (cfTemp.hasOwnProperty(action.item_id)) {
        // find the index of the value to delete
        let indexToDelete = cfTemp[action.item_id].indexOf(input_name);

        // if the value is found in the array, remove it
        if (indexToDelete > -1) {
            cfTemp[action.item_id].splice(indexToDelete, 1);
            isChanged = true;
        }

        if (cfTemp[action.item_id].length < 1) {
            delete cfTemp[action.item_id];
            isChanged = false;
        }
    }
    if (Object.keys(cfTemp).length < 1)
        setSaveAvailable(false);
    else {
        setSaveAvailable(true);
    }

    if (isChanged) {
        setChangeFields(cfTemp)
    }

}

/**
 * this function checks if there is a difference between two arrays
 * @param     {Array}    array1
 * @param     {Array}    array2
 * @param     {array}   keys
 * @returns   {boolean}
 * @author    Abdullah Onur Yeşil
 */
export function checkTheDifference(array1, array2, keys = undefined) {
    if (!array1 && !array2) {
        return false;
    } else if (!array1 || !array2) {
        return true;
    } else if (array1.length !== array2.length) {
        return true;
    }

    let isArrayObject = keys && keys.length && (typeof array1[0] === 'object' || (array1.length && array1[0][keys[0]]) || (array2.length && array2[0][keys[0]]))
    if (isArrayObject) {
        // make a copy of array2
        let array2Kopya = [...array2];

        for (let i = 0; i < array1.length; i++) {
            const index = array2Kopya.findIndex(obje => {
                let result = true;
                for (const key of keys) {
                    if (array1[i][key]?.value !== undefined || obje[key]?.value !== undefined) {
                        if (obje[key]?.value !== array1[i][key]?.value) {
                            result = false;
                        }
                    } else {
                        if (obje[key] !== array1[i][key]) {
                            result = false;
                        }
                    }

                }
                return result;
            });
            if (index === -1) {
                //  array2'de aynı değeri içeren bir obje bulunamazsa true döndür
                return true;
            }
            // subtract the found object from array2Copy
            array2Kopya.splice(index, 1);
        }
        return false;
    } else {
        const result1 = array1.filter(element => !array2.includes(element));
        const result2 = array2.filter(element => !array1.includes(element));
        return result1.length > 0 || result2.length > 0;
    }

}

export async function createNewFlow(typeId, navigate, t, setAlert) {
    let mateId = null;
    const resp = await MateService.getAllMates();
    if (resp?.status) {
        if (resp.data.length > 0) {
            resp.data.forEach((mate) => {
                if (mate.is_default_device) {
                    mateId = mate.id;
                }
            });
        }
    }

    const now = new Date().getTime();
    let newAutomData = {
        name: 'autom_' + now,
        description: "",
        type_id: typeId,
        integration_type: "STANDARD",
        timeOut: 5000,
        mate_id: mateId,
        queue_enabled: false,
        qpool_id: ""
    };

    const response = await AutomService.postAutom(newAutomData);

    if (response.status) {
        navigate(`/automs/${response.id}/autom/edit`);
    } else {
        setAlert(alert => ({
            ...alert,
            show: true,
            message: t("MESSAGES.AUTOMS." + response.message),
            severity: 'error'
        }));
    }
}

export function updateFlowItems(items, tmpActions, actions) {
    for (let item of items) {
        if (item.debugStatus) {
            item.debugStatus = '';
        }

        if (actions[item.id]) {
            item.fields = actions[item.id].fields
            item.inputs = actions[item.id].inputs
            if (item.label) {
                tmpActions[item.id].label = item.label;
            }
        }
        if (item.children) {
            updateFlowItems(item.children, tmpActions, actions)
        }
    }
}

export async function extractAreaAsBase64FromImage(imageBase64, x, y, w, h) {
    return new Promise((resolve, reject) => {
        const image = new Image();

        image.src = imageBase64;

        image.onload = function () {
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");

            canvas.width = w;
            canvas.height = h;

            ctx.drawImage(image, x, y, w, h, 0, 0, w, h);

            const croppedBase64 = canvas.toDataURL();

            resolve(croppedBase64);
        }
        image.onerror = function (error) {
            reject(error);
        }
    });
}

export function getImageResolution(base64Image) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = function () {
            resolve({ width: this.width, height: this.height });
        };
        img.onerror = function () {
            reject(new Error('Failed to load image'));
        };
        img.src = base64Image;
    });
}

export function generateRandomString(length) {
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz';
    let result = '';

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * chars.length);
        result += chars.charAt(randomIndex);
    }

    return result;
}

export function convertCoordinates(x, y, width, height, oldResolution, newResolution) {
    const oldWidth = oldResolution.width;
    const oldHeight = oldResolution.height;
    const newWidth = newResolution.width;
    const newHeight = newResolution.height;

    const newX = Math.floor((x / oldWidth) * newWidth);
    const newY = Math.floor((y / oldHeight) * newHeight);
    const newWidthScaled = Math.floor((width / oldWidth) * newWidth);
    const newHeightScaled = Math.floor((height / oldHeight) * newHeight);

    return {
        x: newX,
        y: newY,
        width: newWidthScaled,
        height: newHeightScaled,
    };
}


export function getUserDetailFromJwt() {
    try {
        const authToken = localStorage.getItem("authToken");
        const token = JSON.parse(JSON.stringify(authToken));
        return jwtDecode(token);
    } catch (error) {
        return undefined;
    }
}
export function getLocalItemsForPagination(from) {
    try {
        const user = getUserDetailFromJwt()
        if (localStorage.getItem(`${user.id}_${from}`)) {
            const isOk = localStorage.getItem(`${user.id}_${from}`)
            if (isOk !== "undefined" && isOk !== null && isOk) {
                return localStorage.getItem(`${user.id}_${from}`)
            }
            else {
                return 10
            }
        }
        return 10
    } catch (error) {
        return 10;
    }
}
export function setLocalItemsForPagination(from, value) {
    try {
        const user = getUserDetailFromJwt()
        if (value !== "undefined" && value !== null && value) {
            localStorage.setItem(`${user.id}_${from}`, value)
        }
    } catch (error) {
        console.log("error: ", error)
    }
}

/**
 * this function checks the provided uri and the current base uri of the environment and compare them to avoid facing with the wrong image path from the exported automs
 * @param     {string}    base_origin
 * @param     {string}    uri
 * @returns   {string}    new uri
 * @author    Onur DOGUCU
 */
export function fixBaseOrigin(base_origin, uri) {
    try {
        if (uri.includes(base_origin)) return uri;

        const parsedUrl = new URL(uri);
        return base_origin + parsedUrl.pathname + parsedUrl.search + parsedUrl.hash;
    } catch (error) {
        return uri;
    }
}

// const rules = (oldItem, newItem) => {
//     if ((newItem.children || oldItem.children) && (oldItem.children?.length !== newItem.children?.length)) {
//         isSame = false
//     }
//     else if (oldItem.id !== newItem.id) {
//         isSame = false
//         return
//     }
//     else if (oldItem.isDebugging !== newItem.isDebugging) {
//         isSame = false
//     }
//     else if ((oldItem?.label !== newItem?.label) || (newItem.fields?.hasOwnProperty("label") && ((newItem.fields?.label.value && oldItem?.label !== undefined) && (newItem.fields?.label.value !== oldItem?.label)))) {
//         isSame = false
//     }
//     else if (newItem.fields && newItem.fields.destination && newItem.fields.destination.value && newItem.fields.destination.value?.name &&
//         ((oldItem.fields?.destination?.value?.name !== newItem.fields.destination.value.name) || !oldItem.fields?.destination?.value?.name)
//     ) {
//         isSame = false
//     }
// }

export function findDifferent(prevItem, nextItem, prevProps, nextProps) {
    let isSame = true
    const rules = (oldItem, newItem) => {
        if ((newItem.children || oldItem.children) && (oldItem.children?.length !== newItem.children?.length)) {
            return false
        }
        else if (oldItem.id !== newItem.id) {
            return false
        }
        else if (oldItem.isDebugging !== newItem.isDebugging) {
            return false
        }
        else if ((oldItem?.label !== newItem?.label) || (newItem.fields?.hasOwnProperty("label") && ((newItem.fields?.label.value && oldItem?.label !== undefined) && (newItem.fields?.label.value !== oldItem?.label)))) {
            return false
        }
        else if ((newItem.debugStatus || oldItem.debugStatus) && (oldItem.debugStatus !== newItem.debugStatus)) {
            return false
        }
        else if (oldItem.hidden !== newItem.hidden) {
            return false
        }
        else if (oldItem.hiddenParent !== newItem.hiddenParent) {
            return false
        }
        else if (oldItem.visible !== newItem.visible) {
            return false
        }
        else if (oldItem.tabParent !== newItem.tabParent) {
            return false
        }
        else if (newItem.fields && newItem.fields.destination && newItem.fields.destination.value && newItem.fields.destination.value?.name &&
            ((oldItem.fields?.destination?.value?.name !== newItem.fields.destination.value.name) || !oldItem.fields?.destination?.value?.name)
        ) {
            return false
        }
        else if (newItem.fields && newItem.fields?.data?.value?.outputVariable &&
            ((oldItem.fields?.data?.value?.outputVariable !== newItem.fields?.data?.value?.outputVariable) || !oldItem.fields?.data?.value?.outputVariable)
        ) {
            return false
        }
        return true
    }
    if (!rules(prevItem, nextItem)) {
        isSame = false
    }
    if (prevItem.children && isSame) {
        const findChildChange = (prevChild, nextChild) => {
            for (let i = 0; i < prevChild.length; i++) {
                if (nextChild && prevChild) {
                    if (!rules(prevChild[i], nextChild[i])) {
                        isSame = false
                        return
                    }
                    else if (nextChild[i].children && prevChild[i].children) {
                        findChildChange(prevChild[i].children, nextChild[i].children)
                    }
                }
            }
            // if (!isSame) {
            //     debugger;
            //     differentItems.push({ id: prevChild.id })
            // }
        }
        findChildChange(prevItem.children, nextItem.children)
        // if (differentItems.length) {
        //     const isOk = JSON.parse(localStorage.getItem("differentItems"))
        //     if (!isOk) {
        //         debugger;
        //         localStorage.setItem("differentItems", JSON.stringify(differentItems))
        //     }
        // }
    }
    if (prevProps.groupable?.children) {
        // Last item checking prev and next
        if (prevProps.groupable.children.length) {
            if (prevProps.groupable.children[prevProps.groupable.children.length - 1].item_id !== prevProps.item.item_id) {
                if (nextProps.groupable.children[nextProps.groupable.children.length - 1].item_id === nextProps.item.item_id) {
                    isSame = false
                }

            }
            else if (prevProps.groupable.children[prevProps.groupable.children.length - 1].item_id === prevProps.item.item_id) {
                if (nextProps.groupable.children[nextProps.groupable.children.length - 1].item_id !== nextProps.item.item_id) {
                    isSame = false
                }

            }
        }
    }
    if (prevProps.debuggingStart !== nextProps.debuggingStart) {
        isSame = false
    }
    if (prevProps.isEhFlow !== nextProps.isEhFlow) {
        isSame = false
    }
    if (prevProps.isDesktopRecorder !== nextProps.isDesktopRecorder) {
        isSame = false
    }
    return isSame
}

export function selectDifferentItem(differentItems, prevItem, nextItem) {
    let findItem = true
    for (let item of differentItems) {
        if (item.id === prevItem.id || item.id === nextItem.id) {
            findItem = false
            return
        }
    }
    return findItem
}

export function checkDifferentLibraryShade(library_name) {
    switch (library_name) {
        case "ServiceNow":
            return { dynamicBg: "rgb(143, 172, 168)", shade: "rgb(224, 235, 233)" }
        case "AUTOM-MATE":
            return { dynamicBg: "rgb(89 132 167)", shade: "rgb(217 238 255)" }
        case "Xurrent":
            return { shade: "rgb(153, 173, 193)" }
        case "Ivanti Service Manager":
            return { shade: "rgb(249 205 205)" }
        case "HaloITSM":
            return { shade: "rgb(169, 242, 242)" }
        default:
            return {}
    }
}

export function getVariableIcon(name, classes, fill) {
    switch (name) {
        case "array":
            return <ArrayIcon fill={fill} className={`select-variable-icon ${classes}`} />
        case "boolean":
            return <BooleanIcon fill={fill} className={`select-variable-icon ${classes}`} />
        case "data table":
            return <DataTableIcon fill={fill} className={`select-variable-icon ${classes}`} />
        case "date":
            return <DateIcon fill={fill} className={`select-variable-icon ${classes}`} />
        case "dictionary":
            return <DictionaryIcon fill={fill} className={`select-variable-icon ${classes}`} />
        case "number":
            return <NumberIcon fill={fill} className={`select-variable-icon ${classes}`} />
        case "object":
            return <ObjectIcon fill={fill} className={`select-variable-icon ${classes}`} />
        case "string":
            return <StringIcon fill={fill} className={`select-variable-icon ${classes}`} />
        default:
            return undefined
    }
}

const customInputOutputTheme = {
    ...chromeLight, // chromeDark temasını baz al
    BASE_BACKGROUND_COLOR: '#F3F3F3', // Arka plan rengini değiştir
    BASE_COLOR: 'black', // Metin rengini değiştir
    TREENODE_FONT_SIZE: '12px',
    TREENODE_LINE_HEIGHT: '1.5',
    ARROW_COLOR: "#5F5F5F"
};

export const convertTimestampToDate = (timestamp) => {
    // Nanoseconds'u milisaniyeye dönüştür
    const milliseconds = Math.floor(timestamp / 1_000_000);

    // JavaScript Date nesnesi oluştur
    const date = new Date(milliseconds);

    // Tarihi istenilen biçimde formatla
    const options = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        fractionalSecondDigits: 2, // Milisaniyeyi eklemek için
        hour12: true // 12 saat formatı için
    };

    // Yerel tarih formatına çevir
    return date.toLocaleString('en-US', options);
};

export const formatNanosecondsDifference = (start, end) => {
    // Farkı hesapla (nanosecond cinsinden)
    const differenceInNanoseconds = end - start;

    // Nanosecond'u milisaniyeye çevir (1 milisaniye = 1.000.000 nanosecond)
    const differenceInMilliseconds = differenceInNanoseconds / 1_000_000;

    // Milisaniyeyi saat, dakika, ve saniye cinsine çevir
    const hours = Math.floor(differenceInMilliseconds / (1000 * 60 * 60));
    const minutes = Math.floor((differenceInMilliseconds % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((differenceInMilliseconds % (1000 * 60)) / 1000);
    const milliseconds = Math.floor(differenceInMilliseconds % 1000);

    // Sonucu formatla
    let result = '';
    if (hours > 0) result += `${hours} h `;
    if (minutes > 0) result += `${minutes} m `;
    result += `${(seconds + milliseconds / 1000).toFixed(2)} sec`;

    return result.trim();
};

export const renderDataTable = (logOutput, screen) => {
    if (!logOutput) {
        return undefined
    }

    let v = logOutput.value;
    if (!Array.isArray(logOutput.value) && logOutput.value[0]) {
        v = logOutput.value[0];
    }
    if (screen === "fullScreen") {
        return v.map((row, index) => {
            const backgroundColor = index === 0 ? '#4F6E90' : '#F4F4F4';
            const color = index === 0 ? '#F8F8F8' : '#4A4A4A';

            return (
                <tr key={index} style={{ backgroundColor, color }}>
                    {row.map((cell, cellIndex) => {
                        return <td className={index === 0 ? "data-table-first-header-td" : ""} key={cellIndex}>{typeof cell === 'object' ? JSON.stringify(cell) : cell}</td>;
                    })}
                </tr>
            );
        });
    }
    else {
        return v.slice(0, Math.min(5, v.length)).map((row, index) => {
            const backgroundColor = index === 0 ? '#4F6E90' : '#F4F4F4';
            const color = index === 0 ? '#F8F8F8' : '#4A4A4A';

            return (
                <tr key={index} style={{ backgroundColor, color }}>
                    {row.slice(0, Math.min(2, row.length)).map((cell, cellIndex) => {
                        return <td className={index === 0 ? "data-table-first-header-td" : ""} key={cellIndex}>{typeof cell === 'object' ? JSON.stringify(cell) : cell}</td>
                    })}
                </tr>
            );
        });
    }
};

// -string 10.000 karakter limiti
// -number 10 basamaklı karakter limiti
// -array 1000 limiti
// -data table 1000 limit
// -object 1000 limit (her key kontrol edilecek)

const findMaxLimit = (total_count, valueType, limit) => {
    switch (valueType) {
        case "string":
            return `Displaying ${limit} of ${total_count} items.`
        case "number":
            return `Displaying the first ${limit} digits of a ${total_count}-digit number.`
        case "array":
        case "data table":
            return `Displaying ${limit} of ${total_count} items.`
        case "object":
            return `Displaying ${limit} of ${total_count} items.`
        default:
            return `Displaying ${limit} of ${total_count} items.`
    }
}

const showLimit = (limitObj, currentPath, valueType) => {
    // const limit = Object.values(limitObj.sys_inputs_total_counts)
    let limit = []
    // if (limitObj.sys_inputs_total_counts) {
    //     limit = limitObj.sys_inputs_total_counts ? Object.values(limitObj.sys_inputs_total_counts) : [];
    // }
    if (limitObj.sys_inputs_total_counts) {
        if (limitObj.sys_inputs_total_counts.length) {
            limit = limitObj.sys_inputs_total_counts
        }
        else {
            limit = limitObj.sys_inputs_total_counts ? Object.values(limitObj.sys_inputs_total_counts) : [];
        }
    }
    else if (limitObj.total_counts) {
        limit = limitObj.total_counts
    }
    // const limit = limitObj.sys_inputs_total_counts ? Object.values(limitObj.sys_inputs_total_counts) : [];
    const finded = limit.find((item) => item?.path === currentPath)
    if (finded && finded.total_count) {
        return <div className="log-entries-limit-text">{findMaxLimit(finded.total_count, finded.type, finded.limit)}</div>
    }
    else if (finded && finded.total_row_count) {
        return <div className="log-entries-limit-text">{findMaxLimit(finded.total_row_count, finded.type, finded.limit)}</div>
    }
    else if (finded && finded.total_column_count) {
        return <div className="log-entries-limit-text">{findMaxLimit(finded.total_column_count, finded.type, finded.limit)}</div>
    }
    else if (currentPath === null && limitObj && limitObj.sys_inputs_total_counts && limitObj.sys_inputs_total_counts.total_count) {
        const limitedData = limitObj.sys_inputs_total_counts
        return <div className="log-entries-limit-text">{findMaxLimit(limitedData.total_count, valueType, limitedData.limit)}</div>
    }
    return ""
}


const CustomObjectInspector = ({ data, valueType, theme, limitObj }) => {
    const [pathMap] = useState(new Map());

    const customNodeRenderer = ({ depth, name, data, isNonenumerable, expanded }) => {
        const parentPath = pathMap.get(depth - 1) || '';
        const currentPath = parentPath ? `${parentPath}[${name || ''}]` : name || '';

        pathMap.set(depth, currentPath);

        return (
            <>
                {/* Varsayılan label */}
                <ObjectLabel name={name || data} data={data} isNonenumerable={isNonenumerable} />

                {/* Path bilgisini gösteren bir buton */}
                {
                    limitObj ? showLimit(limitObj, currentPath, valueType) : ""
                }
            </>
        );
    };

    return (
        <ObjectInspector
            data={data}
            theme={theme}
            nodeRenderer={customNodeRenderer}
        />
    );
};

export const isJSONParsable = (str) => {
    try {
        JSON.parse(str);
        return true;
    } catch (e) {
        return false;
    }
}

export const showPreviewData = (value, valueType, cantparse, screen) => {
    try {
        const logOutput = cantparse ? value : JSON.parse(value) ? JSON.parse(value) : value;
        const keyToExtract = "sys_inputs_total_counts";
        if (logOutput && (logOutput.type || valueType)) {
            let extracted
            const logEntrie = logOutput.value ? logOutput.value : logOutput ? logOutput : {}
            if (logEntrie[keyToExtract]) {
                extracted = { [keyToExtract]: logEntrie[keyToExtract] };
                delete logEntrie[keyToExtract];
            }
            else if (logOutput.total_counts) {
                // extracted = { [keyToExtract]: { total_count: logOutput.total_counts, limit: logOutput.limit, path: logOutput.path } };
                extracted = { ["total_counts"]: logOutput.total_counts };
            }
            else if (logOutput.total_count) {
                extracted = { [keyToExtract]: { total_count: logOutput.total_count, limit: logOutput.limit, path: logOutput.path } };
            }
            switch (valueType ? valueType : logOutput.type) {
                case "string":
                case "number":
                case "date":
                case "boolean":
                case "base64":
                    return <>
                        <div className={`all-logs-output-string clear-text-content`}>
                            <>
                                <span>{cantparse ? logOutput : logOutput.value}</span>
                                {
                                    extracted ? showLimit(extracted, null, valueType ? valueType : logOutput.type) : ""
                                }
                            </>
                        </div>

                    </>
                case "object":
                case "array":

                    const logEntries = logOutput.value ? logOutput.value : logOutput ? logOutput : {}
                    return (<CustomObjectInspector data={logEntries} theme={customInputOutputTheme} limitObj={extracted} valueType={valueType ? valueType : logOutput.type} />
                    );
                case "data table":
                    const isFullScreen = screen === "fullScreen"
                    return (
                        <div className={`transform-preview-container ${screen === "fullScreen" ? "transform-preview-container-fullscreen" : "transform-preview-container-miniscreen"}`}>
                            <div style={{ textAlign: "center" }}>
                                <div className='transform-table-container overflow-hidden'>
                                    <table className='transform-data-table-container' style={{ tableLayout: isFullScreen ? "auto" : "fixed" }}>
                                        <tbody>
                                            {renderDataTable(logOutput, screen)}
                                        </tbody>
                                    </table>
                                    {screen !== "fullScreen" && logOutput.value && logOutput.value.length > 5 ? <Tooltip placement="top" title="More rows">
                                        <MoreVertIcon style={{ marginTop: "5px" }} />
                                    </Tooltip> : ""}
                                </div>
                            </div>
                            {screen !== "fullScreen" && logOutput.value && logOutput.value.length && logOutput.value[0].length > 2 ? <Tooltip placement="top" title="More columns">
                                <MoreHorizIcon style={{ marginLeft: "5px" }} />
                            </Tooltip>
                                : ""}
                        </div>
                    );
                case "dictionary":
                    return <div></div>;
                default:
                    break;
            }
        }
        return <div></div>;
    } catch (error) {
        console.log("error: ", error);
    }
};